export default __webpack_public_path__ + "static/media/estrava_notext.e60b01e5.svg";